import React from 'react';
import { Box } from '@mui/material';
import { EmailAnalytics } from '../../types';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ReactLoading from 'react-loading';

const OpenEmailStatistics = ({
  isLoading,
  emailAnalytics
}: {
  isLoading: boolean;
  emailAnalytics: EmailAnalytics;
}) => {
  ChartJS.register(ArcElement, Tooltip, Legend);

  const stats = emailAnalytics?.statistics?.status_statistics;

  if (!stats) {
    return <Box>No open email statistics available</Box>;
  }

  const openEmailData = {
    labels: ['Not Opened', 'Opened'],
    datasets: [
      {
        label: 'Open Email Statistics',
        data: [stats.datasets[1]?.data[0] || 0, stats.datasets[1]?.data[1] || 0],
        backgroundColor: ['rgba(236, 110, 133, 1)', 'rgba(98, 203, 204, 1)'],
        hoverOffset: 4
      }
    ]
  };

  const openEmailOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const
      },
      title: {
        display: true,
        text: 'Open Email Statistics'
      }
    }
  };

  return (
    <Box
      sx={{
        border: '1px solid #E3E3E3',
        borderRadius: '3px',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        height: '400px',
        marginTop: '50px'
      }}
    >
      {isLoading ? (
        <Box
          sx={{
            height: '300px',
            margin: 'auto',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex'
          }}
        >
          <ReactLoading type="spin" color="#084D6D" width={100} height={100} />
        </Box>
      ) : (
        <Box sx={{ position: 'relative', minHeight: '300px', maxHeight: '500px' }}>
          <Pie data={openEmailData} options={openEmailOptions} />
        </Box>
      )}
    </Box>
  );
};

export default OpenEmailStatistics;
